// File: src/pages/Admin/GPTMaintainerAdmin.js

import React, { useState } from "react";
import axios from "axios";
import config from "../../config/config";
import AdminPageFrame from "../../components/admin/AdminPageFrame";

const GPTMaintainerAdmin = () => {
  const [files, setFiles] = useState(["src/controllers/userController.js"]);
  const [task, setTask] = useState(
    "Analysiere die Dateien auf ungenutzte Funktionen, veraltete Routen oder Refactoring-Möglichkeiten."
  );
  const [language, setLanguage] = useState("de");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleRun = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/gpt/maintain`, {
        files,
        task,
        language
      });
      setResult(res.data);
    } catch (err) {
      console.error("❌ Fehler beim GPT-Aufruf:", err);
      setResult({ error: err.response?.data?.error || "Unbekannter Fehler" });
    } finally {
      setLoading(false);
    }
  };

  const handleAddFile = () => setFiles([...files, ""]);
  const handleFileChange = (i, value) => {
    const updated = [...files];
    updated[i] = value;
    setFiles(updated);
  };

  return (
    <AdminPageFrame
      title="GPT Maintainer"
      subtitle="Codeanalyse, Dateiauswahl und Maintainer-Aufgaben in derselben Admin-Shell."
      badge="GPT Operations"
    >
      <div className="admin-workbench">
        <section className="admin-workbench__panel">
          <div className="admin-workbench__field">
            <label>Dateien analysieren</label>
            {files.map((file, i) => (
              <input
                key={i}
                type="text"
                value={file}
                onChange={(e) => handleFileChange(i, e.target.value)}
                className="admin-workbench__input"
              />
            ))}
            <div className="admin-workbench__actions">
              <button type="button" onClick={handleAddFile} className="admin-workbench__button admin-workbench__button--secondary">
                Weitere Datei hinzufuegen
              </button>
            </div>
          </div>

          <div className="admin-workbench__field">
            <label htmlFor="gpt-maintainer-task">Aufgabe</label>
            <textarea
              id="gpt-maintainer-task"
              rows={4}
              value={task}
              onChange={(e) => setTask(e.target.value)}
              className="admin-workbench__textarea"
            />
          </div>

          <div className="admin-workbench__grid admin-workbench__grid--split">
            <div className="admin-workbench__field">
              <label htmlFor="gpt-maintainer-language">Sprache</label>
              <select
                id="gpt-maintainer-language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="admin-workbench__select"
              >
                <option value="de">Deutsch</option>
                <option value="en">English</option>
                <option value="fr">Franzoesisch</option>
              </select>
            </div>
          </div>

          <div className="admin-workbench__actions">
            <button
              type="button"
              onClick={handleRun}
              disabled={loading}
              className="admin-workbench__button admin-workbench__button--primary"
            >
              {loading ? "Analysiere..." : "Analyse starten"}
            </button>
          </div>
        </section>

        {result ? (
          <section className="admin-workbench__panel">
            <div>
              <h3>Analyse-Ergebnis</h3>
            </div>
            {result.error ? (
              <pre className="admin-workbench__code">{result.error}</pre>
            ) : (
              <pre className="admin-workbench__output">{result.output}</pre>
            )}
          </section>
        ) : null}
      </div>
    </AdminPageFrame>
  );
};

export default GPTMaintainerAdmin;
